module.exports = __webpack_public_path__ + "static/expertiseSubPageHeader-343b8c5259ec2a3b57dc692afe24009d.png";